/**
 * Parsea JSON de forma segura. Retorna `fallback` si el valor es null,
 * undefined, o si JSON.parse lanza un error.
 *
 * @param {string|null} value - El string a parsear
 * @param {*} fallback - Valor por defecto si falla (default: null)
 * @returns {*} El valor parseado o el fallback
 */
export const safeJsonParse = (value, fallback = null) => {
  if (value === null || value === undefined) return fallback;
  try {
    return JSON.parse(value) ?? fallback;
  } catch {
    return fallback;
  }
};

/**
 * Obtiene y parsea un item de localStorage de forma segura.
 *
 * @param {string} key - La clave del localStorage
 * @param {*} fallback - Valor por defecto si falla (default: null)
 * @returns {*} El valor parseado o el fallback
 */
export const getLocalStorage = (key, fallback = null) => {
  try {
    return safeJsonParse(localStorage.getItem(key), fallback);
  } catch {
    return fallback;
  }
};

/**
 * Obtiene y parsea un item de sessionStorage de forma segura.
 *
 * @param {string} key - La clave del sessionStorage
 * @param {*} fallback - Valor por defecto si falla (default: null)
 * @returns {*} El valor parseado o el fallback
 */
export const getSessionStorage = (key, fallback = null) => {
  try {
    return safeJsonParse(sessionStorage.getItem(key), fallback);
  } catch {
    return fallback;
  }
};
